// extracted by mini-css-extract-plugin
export default {"body":"styles_body__hqynn","error":"styles_error__BZucA","with-error":"styles_with-error__rlt4O","input-error":"styles_input-error__zcoK6"};